import { Dialog } from "@ark-ui/react";
import { cn } from "@base/lib/utils";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Dialog.Title> & {
  className?: string;
};

const Title = ({ className, ...rest }: Props) => (
  <Dialog.Title className={cn("text-center text-gray-1000 text-subtitle2", className)} {...rest} />
);

export default Title;
